import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Oval } from "react-loader-spinner";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import network from "./utils/Network";
import DynamicRouter from "./utils/DynamicRouter";
import { ReactComponent as Logo } from "./assets/logo-solo.svg";
import MaintenanceIndicator from "./components/MaintenanceIndicator/MaintenanceIndicator";

const LoadingIndicator = ({ children }) => {
  const { promiseInProgress } = usePromiseTracker();
  const isTokenizeRoute = window.location.pathname === "/tokenize";

  if (promiseInProgress && !isTokenizeRoute) {
    return (
      <div
        style={{
          backgroundColor: "#FFFFFF",
          width: "100%",
          height: "100%",
          overflow: "hidden",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          zIndex: 10000,
        }}
      >
        <Logo style={{ fill: "#100EA0", height: "100px", paddingRight: "3rem" }} />
        <Oval
          height={80}
          width={80}
          color="#100EA0"
          visible={true}
          ariaLabel="oval-loading"
          secondaryColor="#100EA0"
          strokeWidth={2}
          strokeWidthSecondary={2}
        />
      </div>
    );
  }

   return children || null;
};

LoadingIndicator.propTypes = {
  children: PropTypes.node,
};

LoadingIndicator.defaultProps = {
  children: null,
};

function App() {
  const [appData, setAppData] = useState(null);
  const [strapiHasError, setStrapiHasError] = useState(false);

  useEffect(() => {
    trackPromise(
      axios
        .all([
          axios.get(
            network.apiBase + "pages?pagination[limit]=50&populate=deep",
          ),
          axios.get(network.apiBase + "map-datas?pagination[limit]=50"),
          axios.get(network.apiBase + "footer?populate=page_links"),
          axios.get(network.apiBase + "main-menus?populate=deep"),
          axios.get(
            network.apiBase + "careers?pagination[limit]=50&populate=*",
          ),
        ])
        .then(
          axios.spread(function (pages, mapData, footer, menus, careers) {
            setAppData({
              pages: pages.data.data,
              maps: mapData.data.data,
              footer: footer.data.data,
              menus: menus.data.data,
              careers: careers.data.data,
            });
          }),
        )
        .catch((error) => {
          setStrapiHasError(true);
        }),
    );
    AOS.init({
      duration: 600,
    });

    // AOS.refresh();
  }, []);
  return (
    <div className="app">
      <LoadingIndicator />
      {appData && (
        <DynamicRouter
          pages={appData.pages}
          menus={appData.menus}
          footer={appData.footer}
          maps={appData.maps}
          careers={appData.careers}
        />
      )}
      {strapiHasError && (
        <MaintenanceIndicator
          errorMessage={[
            "Our website is currently undergoing maintenance.",
            "Please check our status page for additional details.",
          ]}
        />
      )}
    </div>
  );
}

export default App;
